/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Component } from '@angular/core';
import { BuilderUserContext } from '@gh/builder-shared';

@Component({
  standalone: false,
  selector: 'gh-contacts-tab-container',
  templateUrl: 'contacts-tab-container.component.html',
  styleUrls: ['contacts-tab-container.component.scss'],
})
export class ContactsTabContainerComponent {
  constructor(public userContext: BuilderUserContext) {
  }
}
